import { Tooltip } from "../tooltip/Tooltip"
import style from "./TooltipWithDimensions.module.scss"

const { modelNumbers } = style

type Props = {
	item: {
		modelNumbers: string[]
		dimensions?: Record<
			string,
			{
				min_width: number
				max_width: number
				min_height: number
				max_height: number
				min_depth: number
				max_depth: number
			}
		>
	}
}

export const TooltipWithDimensions = ({ item }: Props) => {
	return (
		<div className={modelNumbers}>
			{item?.modelNumbers.map((modelNumber: string, index: number) => {
				const dimensions = item?.dimensions?.[modelNumber]
				const tooltipText = dimensions
					? `Width: ${dimensions.min_width}-${dimensions.max_width}, Height: ${dimensions.min_height}-${dimensions.max_height}, Depth: ${dimensions.min_depth}-${dimensions.max_depth}`
					: "No dimensions available"

				return (
					<span key={modelNumber}>
						<Tooltip text={tooltipText} placement="bottom">
							<span>{modelNumber}</span>
						</Tooltip>
						{index < (item?.modelNumbers?.length ?? 0) - 1 && ", "}
					</span>
				)
			})}
		</div>
	)
}
